import "./Mentions.css";
import Header from "./Header.js"

function Mentions() {
return (
    <div id="mentions">
        <div id="headerMentions">
        <div id="imgHeaderMentions">
        </div>
        <Header /></div>

        <div id="contentMentions">
            <h3 id="mentionsTitle">Mentions Légales</h3>
            <hr/>
            <p class="mentionsSTitle">MENTIONS LEGALES - ASSOCIATION DE LOI 1901 : </p>
            <p class="mentionsSubtitle">IDENTITE</p>
            <p>Nom de l'association : Festival Un Doua De Jazz<br/>
            Adresse Siège Social : Bat 608 MDE BDE - 20 Avenue Albert Einstein - 69100 VILLEURBANNE
<br/>
                Telephone : 0695632301 <br/>
                Co-Présidents de l'Association : Elyn WALTER - Guillaume CARPENTIER<br/>

                Association loi 1901<br/></p>
                <p class="mentionsSubtitle">HEBERGEUR</p>
                <p>
Scaleway<br/>
8 rue de la Ville l’Evêque, 75008 Paris, France<br/>
+33 1 84 13 00 00<br/></p>
            <p class="mentionsSTitle">CONDITIONS D’UTILISATION DU SITE WEB :</p>
            <p>L’utilisation du présent site implique l’acceptation pleine et entière des conditions générales d’utilisation décrites ci-après. Ces conditions d’utilisation sont susceptibles d’être modifiées ou complétées à tout moment.</p>
            <p class="mentionsSubtitle">INFORMATIONS</p>
            <p>Les informations et documents du site sont présentés à titre indicatif, sans de caractère exhaustif, et ne peuvent engager la responsabilité du propriétaire du site.<br/>
                Le propriétaire du site ne peut être tenu responsable des dommages directs et indirects consécutifs à l’accès au site.</p>
            <p class="mentionsSubtitle">PROPRIÉTÉ INTELLECTUELLE</p>
            <p>Sauf mention contraire, tous les éléments accessibles sur le site (textes, images, graphismes, logo, icônes, sons, logiciels, etc.) restent la propriété exclusive de leurs auteurs, en ce qui concerne les droits de propriété intellectuelle ou les droits d’usage.<br/>
            Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de l’auteur.<br/>
            Toute exploitation non autorisée du site ou de l’un quelconque des éléments qu’il contient est considérée comme constitutive d’une contrefaçon et passible de poursuites.<br/>
            Les marques et logos reproduits sur le site sont déposés par les sociétés qui en sont propriétaires.</p>
            <p class="mentionsSubtitle">LIENS</p>
            <p>Liens sortants<br/>
            Le propriétaire du site décline toute responsabilité et n’est pas engagé par le référencement via des liens hypertextes, de ressources tierces présentes sur le réseau Internet, tant en ce qui concerne leur contenu que leur pertinence.<br/>
            Liens entrants<br/>
            Le propriétaire du site autorise les liens hypertextes vers l’une des pages de ce site, à condition que ceux-ci ouvrent une nouvelle fenêtre et soient présentés de manière non équivoque afin d’éviter :
<br/>tout risque de confusion entre le site citant et le propriétaire du site
<br/>ainsi que toute présentation tendancieuse, ou contraire aux lois en vigueur.
<br/>Le propriétaire du site se réserve le droit de demander la suppression d’un lien s’il estime que le site source ne respecte pas les règles ainsi définies.</p>
            <p class="mentionsSTitle">CRÉDITS</p>
            <p><b>Présidence :</b><br/>
            Jeanne Ménière<br/>
            Quentin Zimmer<br/><br/>

            <b>Pôle trésorerie :</b><br/>
            Oriane Renaut<br/>
            Alice Gras<br/><br/>

            <b>Pôle communication :</b><br/>
            Alexis Henriot<br/>
            Joachim Xucla<br/>
            Rémi Faure<br/>
            Rémi Rionnet<br/><br/>

            <b>Secrétaire :</b><br/>
            Alice Invernizzi<br/><br/>

            <b>Responsable environnement</b><br/>
            Guillaume Liebgott<br/><br/>

            <b>Site web :</b> <br/>
            Colin Thomas<br/>
            Alice Invernizzi<br/><br/></p>


            

            </div>
            <hr/>
    </div>
);
}

export default Mentions;